import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Search, Car } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function HowItWorks() {
  const {
    t
  } = useLanguage();
  const steps = [{
    icon: MessageCircle,
    title: t('how.1.title'),
    desc: t('how.1.desc'),
    num: '01'
  }, {
    icon: Search,
    title: t('how.2.title'),
    desc: t('how.2.desc'),
    num: '02'
  }, {
    icon: Car,
    title: t('how.3.title'),
    desc: t('how.3.desc'),
    num: '03'
  }];
  return <section className="py-14 md:py-20 bg-white" data-track="how-it-works" data-id="element-87">
      <div className="container mx-auto px-5 md:px-6" data-id="element-88">
        <div className="text-center mb-10 md:mb-14" data-id="element-89">
          <motion.h2 className="text-2xl md:text-4xl font-black text-[#111111] uppercase tracking-tight" initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-90">
            {t('how.title')}
          </motion.h2>
          <motion.div className="w-12 h-[3px] bg-[#C41230] mx-auto mt-3" initial={{
          width: 0
        }} whileInView={{
          width: 48
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-91" />
        </div>

        <div className="grid grid-cols-3 gap-3 md:gap-8 max-w-4xl mx-auto" data-id="element-92">
          {steps.map((step, i) => <motion.div key={i} className="flex flex-col items-center text-center" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.12
        }} data-id="element-93">
              <div className="relative mb-3 md:mb-5" data-id="element-94">
                <div className="w-16 h-16 md:w-20 md:h-20 bg-[#f4f4f4] rounded-2xl flex items-center justify-center border border-[#e5e5e5]" data-id="element-95">
                  <step.icon className="w-7 h-7 md:w-9 md:h-9 text-[#111111]" data-id="element-96" />
                </div>
                <div className="absolute -top-1.5 -right-1.5 bg-[#C41230] text-white font-black w-6 h-6 md:w-7 md:h-7 rounded-full flex items-center justify-center text-[10px] md:text-xs shadow-md" data-id="element-97">
                  {step.num}
                </div>
              </div>
              <h3 className="text-sm md:text-lg font-bold text-[#111111] mb-1" data-id="element-98">
                {step.title}
              </h3>
              <p className="text-[#6b6b6b] text-[11px] md:text-sm leading-snug max-w-[200px]" data-id="element-99">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}